

    var echarts = require('../echarts');

    require('./sankey/SankeySeries');
    require('./sankey/SankeyView');
    echarts.registerLayout(require('./sankey/sankeyLayout'));
    echarts.registerVisual(require('./sankey/sankeyVisual'));



//////////////////
// WEBPACK FOOTER
// ./~/echarts/lib/chart/sankey.js
// module id = cWq4
// module chunks = 5